import { setInitialCheckForAuthenticationCompleted } from '../../store/reducers/ui/actions';
import { useDispatch } from 'react-redux';
import cookie from 'cookie_js';
import API from '../network';
import { stringIsNullOrUndefinedOrBlank } from '../siteFunctions';

const useAuth = () => {
	const dispatch = useDispatch();

	const signIn = (pin: number, username: string, password: string, callback?: () => any) => {
		API.post('client-portal/authenticate', {
			pin: pin,
			username: username,
			password: password
		})
			.then(data => {
				if (stringIsNullOrUndefinedOrBlank(data.data.jwt)) {
					callback && callback();
				}
				else {
					cookie.set('simplicity-client-portal-jwt', data.data.jwt, { expires: 1 });
					dispatch(setInitialCheckForAuthenticationCompleted(false)).then(() => callback && callback());
				}
			})
			.catch(error => console.error('Error', error));
	};

	const signOut = (callback?: () => any) => {
		cookie.remove('simplicity-client-portal-jwt');
		dispatch(setInitialCheckForAuthenticationCompleted(false));

		if (callback !== undefined && callback !== null)
			callback();
	};

	return {
		signIn,
		signOut
	};
};

export default useAuth;